<template>
    <card-recharge
        v-if="isAmountLoaded"
        :email="email"
        :amount="null"
        :period="period"
        :monthly-cost="monthlyCost"
        :emergency-credit="isEmergencyCredit"
        :is-checkout="true"
        v-on:recharged="onRecharged"
    />
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex'
    import AjaxService     from '@/services/AjaxService'
    import CardRecharge    from '@/components/organisms/CardRecharge'
    import PaymentTemplate from '@/components/templates/PaymentTemplate'
    import store from "@/store"
    import { Api } from '@/plugins/api'
    import ErrorService from "@/services/error.service";

    export default {
        components: {
            CardRecharge,
            PaymentTemplate
        },
        data() {
            return {
                email: "",
                period: 12,
                monthlyCost: 99.9,
                activeServices: 1,
                isAmountLoaded: true,
                isEmergencyCredit: false,
                isRechargeCompleted: false,
            }
        },
        beforeRouteEnter(to, from, next)
        {
            if (to.query.email) {
                next(vm => {
                    vm.email = to.query.email;
                    vm.period = to.query.annual == "1" ? 12 : 1;
                });
            }
            else {
                next('/auth/login');
            }
        },
        beforeRouteLeave(to, from, next)
        {
            if (!this.isRechargeCompleted) {
                if (!confirm('A recarga não foi concluída. Se deixar esta página agora, o pedido poderá ser cancelado. Tem certeza que deseja continuar?')) return;
            }

            AjaxService.cancel();
            next();
        },
        mounted()
        {
            // Unload event
            window.addEventListener('unload', this.onPageUnload);

            // Tag de conversão do Facebook
            if (typeof window.fbq !== "undefined") {
                fbq('track', 'InitiateCheckout');
            }

            // Tag de conversão do Google Ads
            if (typeof window.gtag !== 'undefined') {
                gtag('event', 'conversion', {'send_to': 'AW-798302531/Gf8WCLnakcQBEMPC1PwC'});
            }
        },
        beforeDestroy()
        {
            window.removeEventListener('unload', this.onPageUnload);
        },
        methods: {
            ...mapActions({
                showLoading: 'loading/show',
                hideLoading: 'loading/hide',
                showErrorAlert: 'alert/error',
            }),

            onRecharged()
            {
                this.isRechargeCompleted = true;
                setTimeout(() => this.$eventBus.$emit("credits-recharged"), 5000);
            },

            /**
             * Prevent from leaving page.
             * @param {Event} evt
             */
            onPageUnload(evt)
            {
                if (!this.isRechargeCompleted) {
                    if (!confirm('A recarga não foi concluída. Se deixar esta página agora, o pedido poderá ser cancelado. Tem certeza que deseja continuar?')) {
                        evt.preventDefault();
                        evt.returnValue = false;
                    }
                }
            }
        }
    }
</script>
